import EventManager from "camera/modules/events/EventManager";
import EventEmitter from "@/lib/EventEmitter";
import { useStation } from "camera/store/station";

const MANUAL_VIDEO_DURATION_MS = 60000;

export default class ManualVideoManager {
  private eventId: string | null = null;
  private timeout: NodeJS.Timeout | null = null;

  private emitter = new EventEmitter();
  on = this.emitter.on;
  off = this.emitter.off;

  constructor() {
    useStation.subscribe(
      (store) => store.recordingMode,
      (recordingMode) => {
        if (recordingMode === "OFF") this.endManualVideoEvent();
      }
    );
  }

  startManualVideoEvent = (): CameraEvent | undefined => {
    if (this.timeout || this.eventId) {
      return EventManager.getCurrentEvents().find((e) => e.type === "MANUAL_VIDEO");
    }
    const event = EventManager.startEvent("MANUAL_VIDEO");
    if (!event) return;

    this.eventId = event.uniqueId;
    this.timeout = setTimeout(() => {
      this.endManualVideoEvent();
    }, MANUAL_VIDEO_DURATION_MS);

    return event;
  };

  endManualVideoEvent = (): CameraEvent | undefined => {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (this.eventId) {
      const event = EventManager.endEvent(this.eventId);
      this.eventId = null;

      this.emitter.emit("event-end", event);
      return event;
    }
  };

  getStatus = (): CameraRecordingStatus => {
    if (this.eventId) {
      const event = EventManager.getCurrentEvents().find((e) => e.type === "MANUAL_VIDEO");
      const recordingStart = event?.start || 0;
      const recordingEnd = event?.start ? event.start + MANUAL_VIDEO_DURATION_MS : 0;
      return {
        recordingOn: {
          recordingStart,
          recordingEnd,
          event
        }
      };
    }

    const event = EventManager.getLastManualVideoEvent() as CameraEvent | undefined;
    return { recordingOff: { event: event } };
  };
}
